function updateActiveAddon() {
  let selectedInput = document.querySelector('input[second_option]:checked');

  // Fallback to bundles
  if (!selectedInput) {
    selectedInput = document.querySelector('input[name="bundle"]:checked');
  }

  if (!selectedInput) {
    selectedInput = document.querySelector('input[data-bundle="bundle"]:checked');
  }

  if (!selectedInput) return;

  const selectedValue = (selectedInput.value || '').trim().toLowerCase();
  const selectedNumber = selectedInput.dataset.number;

  let checkedPurchaseOp = document.querySelector('.subs-box-options label.option-card > input:checked');

  let purchaseType = null;

  if (checkedPurchaseOp) {
    if (checkedPurchaseOp.value === 'subscription_op') {
      purchaseType = 'subscription';
    } else if (checkedPurchaseOp.value === 'oneime_op') {
      purchaseType = 'onetime';
    }
  }

  document.querySelectorAll('.addon-product__block').forEach((block) => {
    const rawOptions = block.getAttribute('data-options');
    const activateOn = block.getAttribute('data-show-subscription');

    if (!rawOptions || activateOn === null) return;

    const optionList = rawOptions.split(',').map((opt) => opt.trim().toLowerCase());

    const isTextMatch = optionList.includes(selectedValue);
    const isNumberMatch = optionList.includes(String(selectedNumber));

    const optionMatched = isTextMatch || isNumberMatch;

    let shouldShow = false;

    // If no purchase option selected
    if (purchaseType === null) {
      shouldShow = optionMatched;
    } else {
      shouldShow = optionMatched && (activateOn === 'both' || activateOn === purchaseType);
    }

    if (shouldShow) {
      block.classList.add('addon-product-active');
    } else {
      block.classList.remove('addon-product-active');
    }
  });
}

// run once
document.addEventListener('DOMContentLoaded', updateActiveAddon);

document.addEventListener('freeGiftsUpdate', () => {
  updateActiveAddon();
});
